import React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { buttonVariants } from '@/components/ui/shadcn/button';
import { cn } from '@/lib/utils';
import { VariantProps } from 'class-variance-authority';

export type GlowVariant = 'none' | 'click' | 'hover' | 'always';

const glowClasses: Record<GlowVariant, string> = {
  none: '',
  click: 'btn-glow',
  hover: 'btn-glow-hover',
  always: 'btn-glow-always',
};

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean;
  className?: string;
  /** Glow effect variant: 'hover' (default), 'none', 'click', or 'always' */
  glow?: GlowVariant;
  ref?: React.Ref<HTMLButtonElement>;
}

function Button({ className, variant, size, asChild = false, glow = 'hover', ref, ...props }: ButtonProps) {
  const Comp = asChild ? Slot : 'button';

  return (
    <Comp
      ref={ref}
      data-slot="button"
      className={cn(
        'cursor-pointer',
        buttonVariants({ variant, size }),
        glowClasses[glow],
        className
      )}
      {...props}
    />
  );
}

export { Button, buttonVariants };
